import { render, staticRenderFns } from "./ProductAddDropdown.vue?vue&type=template&id=6c566fa4&scoped=true"
import script from "./ProductAddDropdown.vue?vue&type=script&lang=js"
export * from "./ProductAddDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductAddDropdown.vue?vue&type=style&index=0&id=6c566fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c566fa4",
  null
  
)

export default component.exports